<app-header [showBack]="true"></app-header>

<div class="wrapper">
  <!-- <app-tab-menu></app-tab-menu> -->
  <app-set-meta title="初めての方へ｜Forbes CAREER"></app-set-meta>
  	<div class="about-cnt" style="background-image:url(assets/img/about/bg.png)">
  		<h1>挑戦する人を、応援する<br>挑戦する企業も、支援する</h1>
  		<div class="message">
  			<p>人にも自分にも負けたくないから、常にアップデートし続けてきた<br>
  			あらゆる時間を仕事のために投資し続け、相応の結果は残してきた</p>
  			<p>目立たないかもしれないけど、日本のビジネスパーソンにはカッコイイ人が多い</p>
  			<p>成長のために躍起になっているスタートアップもあれば、地方で静かに牙を研ぎ続ける名企業もある<br>かたや、大企業の中で変革に挑もうと奮闘しているスモールチームも存在する</p>
  			<p>そう、日本の企業には想像以上にカッコイイ人が、チームが、仕事がたくさん眠っている</p>
  			<p>Forbes CAREERでは、<br>
  			“挑戦したい”と考える日本の次世代を担うビジネスパーソンたちと<br>
  			“挑戦したい”と意気込む隠れた名企業、チームとの出会いを創出します</p>
  			<div class="btn">
  				<a href="/signup">新規登録してはじめる</a>
  			</div>
  		</div>
  		<div class="grope">
  			<h2>新たな活躍の場を模索しよう</h2>
  			<p>Forbes CAREERは、日本の変革に挑む企業や人々のストーリーを、<br>
  			新たな活躍の場として皆様にご紹介します。</p>
  			<p>企業や求人に興味を持ったら、「エントリー」をすることで<br>
  			ご自身の情報を企業に伝えることができます。</p>
  			<p>企業の課題をサポートする、将来的なUターン、Iターン、<br>
  			就職先として検討する、様々な選択肢を模索してみましょう。</p>
  			<div class="steps">
	  			<dl>
	  				<dd>
	  					<img src="assets/img/about/find.png">
	  					<strong>見つける</strong>
	  				</dd>
	  				<dt>自分の興味のあるテーマやキーワードに沿って、ストーリーや企業を探してみましょう。</dt>
	  			</dl>
	  			<i class="next"></i>
	  			<dl>
	  				<dd>
	  					<img src="assets/img/about/tell.png">
	  					<strong>興味を伝える</strong>
	  				</dd>
	  				<dt>気になる求人や企業があれば、エントリーをしてあなたの情報を伝えましょう。</dt>
	  			</dl>
	  			<i class="next"></i>
	  			<dl>
	  				<dd>
	  					<img src="assets/img/about/contact.png">
	  					<strong>つながる</strong>
	  				</dd>
	  				<dt>掲載企業があなたのプロフィールに興味を持った場合、担当者からご登録のアドレスに直接連絡がきます。</dt>
	  			</dl>
	  			<i class="next"></i>
	  			<dl>
	  				<dd>
	  					<img src="assets/img/about/talk.png">
	  					<strong>話を聞いてみる</strong>
	  				</dd>
	  				<dt>担当者に返信し、対面もしくは電話などで具体的な話を聞いてみましょう。</dt>
	  			</dl>
	  		</div>
  		</div>
  		<div class="q_a">
  			<h2>よくあるご質問</h2>
  			<dl>
  				<dd>Q. 利用料金は発生しますか？</dd>
  				<dt>全ての機能を無料でご利用いただけます。</dt>
  			</dl>
  			<dl>
  				<dd>Q. エントリーするとどうなりますか？</dd>
  				<dt>採用担当者が興味を持った場合、直接連絡が届きます。いますぐ転職を考えていない場合でも、連絡があれば気軽に担当者と連絡を取り合い、キャリアの選択肢を増やすことをおすすめします。</dt>
  			</dl>
  			<dl>
  				<dd>Q. 登録したプロフィールは公開されますか？</dd>
  				<dt>プロフィールに登録した情報は、応募した企業の採用担当者にのみ送信されます。それ以外の第三者に公開されることはありません。</dt>
  			</dl>
  			<div class="btn">
  				<a href="/signup">新規登録してはじめる</a>
  			</div>
  		</div>
  	</div>
  <app-footer></app-footer>
</div>
<!-- /.wrapper -->
